import { useState, useEffect } from 'react';
import { currentUser } from '../services/authService';

const useCurrentUser = () => {
  const [jwtToken, setjwtToken] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (!loading) {
      if (isMounted) {
        setLoading(true);
      }
      currentUser()
        .then(data => {
          if (isMounted) {
            setjwtToken(data.signInUserSession.accessToken.jwtToken);
            setIsAuthenticated(true);
            setLoading(false);
            setLoaded(true);
          }
        })
        .catch(error => {
          console.log(error);
          if (isMounted) {
            setLoading(false);
            setLoaded(true);
          }
        });
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return { isAuthenticated, loading, loaded, jwtToken };
};

export default useCurrentUser;
